import { useTicketCounters } from "./api";

/**
 * Badge contador del item "Tickets" del sidebar.
 *
 * Muestra el total de tickets en estado abierto+en_proceso (lo que
 * llama "abiertos" en el lenguaje del usuario). Si el count es 0,
 * NO renderiza nada (sin glob amarillo en la sidebar).
 *
 * Refetch automático cada 60s vía useTicketCounters → cuando entra un
 * ticket nuevo desde el portal cliente, el badge se actualiza solo.
 */
export function TicketsBadge() {
  const { data } = useTicketCounters();
  if (!data) return null;
  const total = data.abiertos_total + data.en_proceso_total;
  if (total === 0) return null;
  return (
    <span className="ml-auto bg-amber-500 text-black text-[10px] font-semibold rounded-full px-1.5 min-w-[18px] text-center leading-tight py-px">
      {total > 99 ? "99+" : total}
    </span>
  );
}
